import {ResourceData} from "../../common/resource/resource-service";
import {IStatusBase} from "./status-models";

export class StatusBaseData extends ResourceData<IStatusBase> {
    constructor() {
        super("/v5/competition/status");
    }
}
